import { PropsWithChildren } from "react";

export function MainContainer({ children }: PropsWithChildren) {
  return (
    <div className={"flex flex-1 min-h-scren justify-center items-center p-4"}>
      {children ?? null}
    </div>
  );
}
